// utils/number.ts
export const formatNumberWithCommas = (
  value: number | string | null | undefined
): string | null => {
  if (value === null || value === undefined || value === "") {
    return null;
  }

  const numericValue = Number(value);

  if (!Number.isFinite(numericValue)) {
    return null;
  }

  // System expects empty string for zero
  if (numericValue === 0) {
    return "";
  }

  // Remove decimals without rounding
  const integerValue = Math.trunc(numericValue);

  return integerValue.toLocaleString();
};
export const formatNumberDecimalEnterWithCommas = (
  value: number | string | null | undefined
): string => {
  if (value === null || value === undefined || value === "") {
    return "";
  }

  const stringValue = value.toString().replace(/,/g, "");

  if (isNaN(Number(stringValue))) {
    return "";
  }

  // Split integer & decimal parts
  const [integerPart, decimalPart] = stringValue.split(".");
  const formattedInteger = Number(integerPart).toLocaleString();

  return decimalPart !== undefined
    ? `${formattedInteger}.${decimalPart}`
    : formattedInteger;
};

export const formatNumberDecimalWithCommas = (
  value: number | string | null | undefined
): string | null => {
  if (value === null || value === undefined || value === "") {
    return null;
  }

  const numericValue = Number(value);

  if (!Number.isFinite(numericValue)) {
    return null;
  }

  // System expects empty string for zero
  if (numericValue === 0) {
    return "";
  }
  const integerValue = numericValue;

  return integerValue.toLocaleString();
};

export const formatNumberPlain = (
  value: number | string | null | undefined
): string | null => {
  if (value === null || value === undefined || value === "") {
    return null;
  }

  const numericValue = Number(value);

  if (!Number.isFinite(numericValue)) {
    return null;
  }

  // System expects empty string for zero
  if (numericValue === 0) {
    return "";
  }

  // Remove decimals without rounding
  const integerValue = Math.trunc(numericValue);

  return String(integerValue);
};

export const formatNumericTwoDecimalInputWithCommas = (
  value: number | string | null | undefined
): string => {
  if (value === null || value === undefined || value === "") {
    return "";
  }

  const stringValue = String(value).replace(/,/g, "");

  // Only digits, optional decimal, max 2 digits after decimal
  if (!/^\d*\.?\d{0,2}$/.test(stringValue)) {
    return "";
  }

  const [integerPart, decimalPart] = stringValue.split(".");

  // Add commas WITHOUT converting to Number
  const formattedInteger = integerPart.replace(
    /\B(?=(\d{3})+(?!\d))/g,
    ","
  );

  return decimalPart !== undefined
    ? `${formattedInteger}.${decimalPart}`
    : formattedInteger;
};
